module.exports = __webpack_public_path__ + "static/media/quote_top_bg.da117ecf.png";